import React, { useState, useCallback } from "react";
import { getDisplayName } from "utils/hoc";

const makeToggleable =
  ({ toggleProp = "isActive", isDefaultActive = false } = {}) =>
  (WrappedComponent) => {
    const ToggleableComponent = (props) => {
      const [isToggleActive, setIsToggleActive] = useState(isDefaultActive);

      const toggle = useCallback((toggle) => {
        setIsToggleActive((prevState) =>
          toggle === undefined ? !prevState : toggle,
        );
      }, []);

      const toggleFunctionName =
        "onToggle" + toggleProp[0].toUpperCase() + toggleProp.slice(1);
      const augmentedProps = {
        [toggleProp]: isToggleActive,
        [toggleFunctionName]: toggle,
      };

      return <WrappedComponent {...props} {...augmentedProps} />;
    };

    ToggleableComponent.displayName = `${toggleProp.charAt(0).toUpperCase() + toggleProp.slice(1)}Toggleable${getDisplayName(WrappedComponent)}`;

    return ToggleableComponent;
  };

export default makeToggleable;
